/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import PropTypes from 'prop-types';
import '../css/ChoiceButton.scss';

const ChoiceButton = ({ children, name, type, ...etc }) => (
  <label className="flex body-s text-black-tint-20 mb1">
    <input type={type} name={name} className="flex-none mr2" {...etc} />
    <div style={{ lineHeight: '24px' }}>{children}</div>
  </label>
);

ChoiceButton.defaultProps = {
  children: null,
};

ChoiceButton.propTypes = {
  name: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  children: PropTypes.node,
};

export default ChoiceButton;
